import _construct from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/construct.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/esnext.global-this.js";
import t from "react";
import { transform as e } from "buble-jsx-only";
import r from "@mdx-js/mdx";
import { mdx as n, MDXProvider as o } from "@mdx-js/react";

var i = function i(t) {
  try {
    return !!t();
  } catch (t) {
    return !0;
  }
},
    u = {}.toString,
    c = "".split,
    a = i(function () {
  return !Object("z").propertyIsEnumerable(0);
}) ? function (t) {
  return "String" == function (t) {
    return u.call(t).slice(8, -1);
  }(t) ? c.call(t, "") : Object(t);
} : Object,
    f = function f(t) {
  if (null == t) throw TypeError("Can't call method on " + t);
  return t;
},
    s = function s(t) {
  return a(f(t));
},
    l = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function p(t) {
  var e = {
    exports: {}
  };
  return t(e, e.exports), e.exports;
}

var y,
    g = function g(t) {
  return t && t.Math == Math && t;
},
    v = g("object" == typeof globalThis && globalThis) || g("object" == typeof window && window) || g("object" == typeof self && self) || g("object" == typeof l && l) || function () {
  return this;
}() || Function("return this")(),
    b = !i(function () {
  return 7 != Object.defineProperty({}, 1, {
    get: function get() {
      return 7;
    }
  })[1];
}),
    m = function m(t) {
  return "object" == typeof t ? null !== t : "function" == typeof t;
},
    d = v.document,
    h = m(d) && m(d.createElement),
    O = function O(t) {
  return h ? d.createElement(t) : {};
},
    S = !b && !i(function () {
  return 7 != Object.defineProperty(O("div"), "a", {
    get: function get() {
      return 7;
    }
  }).a;
}),
    j = function j(t) {
  if (!m(t)) throw TypeError(String(t) + " is not an object");
  return t;
},
    w = function w(t, e) {
  if (!m(t)) return t;
  var r, n;
  if (e && "function" == typeof (r = t.toString) && !m(n = r.call(t))) return n;
  if ("function" == typeof (r = t.valueOf) && !m(n = r.call(t))) return n;
  if (!e && "function" == typeof (r = t.toString) && !m(n = r.call(t))) return n;
  throw TypeError("Can't convert object to primitive value");
},
    P = Object.defineProperty,
    T = {
  f: b ? P : function (t, e, r) {
    if (j(t), e = w(e, !0), j(r), S) try {
      return P(t, e, r);
    } catch (t) {}
    if ("get" in r || "set" in r) throw TypeError("Accessors not supported");
    return "value" in r && (t[e] = r.value), t;
  }
},
    L = function L(t, e) {
  return {
    enumerable: !(1 & t),
    configurable: !(2 & t),
    writable: !(4 & t),
    value: e
  };
},
    _ = b ? function (t, e, r) {
  return T.f(t, e, L(1, r));
} : function (t, e, r) {
  return t[e] = r, t;
},
    k = function k(t, e) {
  try {
    _(v, t, e);
  } catch (r) {
    v[t] = e;
  }

  return e;
},
    x = v["__core-js_shared__"] || k("__core-js_shared__", {}),
    E = p(function (t) {
  (t.exports = function (t, e) {
    return x[t] || (x[t] = void 0 !== e ? e : {});
  })("versions", []).push({
    version: "3.9.0",
    mode: "global",
    copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
  });
}),
    M = {}.hasOwnProperty,
    A = function A(t, e) {
  return M.call(t, e);
},
    I = 0,
    R = Math.random(),
    C = function C(t) {
  return "Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++I + R).toString(36);
},
    F = !!Object.getOwnPropertySymbols && !i(function () {
  return !String(Symbol());
}),
    D = F && !Symbol.sham && "symbol" == typeof Symbol.iterator,
    G = E("wks"),
    N = v.Symbol,
    V = D ? N : N && N.withoutSetter || C,
    H = function H(t) {
  return A(G, t) || (G[t] = F && A(N, t) ? N[t] : V("Symbol." + t)), G[t];
},
    W = Math.ceil,
    X = Math.floor,
    q = function q(t) {
  return isNaN(t = +t) ? 0 : (t > 0 ? X : W)(t);
},
    z = Math.min,
    B = Math.max,
    Y = Math.min,
    U = function U(t) {
  return function (e, r, n) {
    var o,
        i,
        u = s(e),
        c = (o = u.length) > 0 ? z(q(o), 9007199254740991) : 0,
        a = function (t, e) {
      var r = q(t);
      return r < 0 ? B(r + e, 0) : Y(r, e);
    }(n, c);

    if (t && r != r) {
      for (; c > a;) {
        if ((i = u[a++]) != i) return !0;
      }
    } else for (; c > a; a++) {
      if ((t || a in u) && u[a] === r) return t || a || 0;
    }

    return !t && -1;
  };
},
    $ = {
  includes: U(!0),
  indexOf: U(!1)
},
    K = {},
    J = $.indexOf,
    Q = function Q(t, e) {
  var r,
      n = s(t),
      o = 0,
      i = [];

  for (r in n) {
    !A(K, r) && A(n, r) && i.push(r);
  }

  for (; e.length > o;) {
    A(n, r = e[o++]) && (~J(i, r) || i.push(r));
  }

  return i;
},
    Z = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"],
    tt = Object.keys || function (t) {
  return Q(t, Z);
},
    et = b ? Object.defineProperties : function (t, e) {
  j(t);

  for (var r, n = tt(e), o = n.length, i = 0; o > i;) {
    T.f(t, r = n[i++], e[r]);
  }

  return t;
},
    rt = v,
    nt = function nt(t) {
  return "function" == typeof t ? t : void 0;
},
    ot = function ot(t, e) {
  return arguments.length < 2 ? nt(rt[t]) || nt(v[t]) : rt[t] && rt[t][e] || v[t] && v[t][e];
},
    it = ot("document", "documentElement"),
    ut = E("keys"),
    ct = function ct(t) {
  return ut[t] || (ut[t] = C(t));
},
    at = ct("IE_PROTO"),
    ft = function ft() {},
    st = function st(t) {
  return "<script>" + t + "<\/script>";
},
    _lt = function lt() {
  try {
    y = document.domain && new ActiveXObject("htmlfile");
  } catch (t) {}

  var t, e;
  _lt = y ? function (t) {
    t.write(st("")), t.close();
    var e = t.parentWindow.Object;
    return t = null, e;
  }(y) : ((e = O("iframe")).style.display = "none", it.appendChild(e), e.src = String("javascript:"), (t = e.contentWindow.document).open(), t.write(st("document.F=Object")), t.close(), t.F);

  for (var r = Z.length; r--;) {
    delete _lt.prototype[Z[r]];
  }

  return _lt();
};

K[at] = !0;

var pt = Object.create || function (t, e) {
  var r;
  return null !== t ? (ft.prototype = j(t), r = new ft(), ft.prototype = null, r[at] = t) : r = _lt(), void 0 === e ? r : et(r, e);
},
    yt = H("unscopables"),
    gt = Array.prototype;

null == gt[yt] && T.f(gt, yt, {
  configurable: !0,
  value: pt(null)
});

var vt = function vt(t) {
  gt[yt][t] = !0;
},
    bt = Function.toString;

"function" != typeof x.inspectSource && (x.inspectSource = function (t) {
  return bt.call(t);
});
var mt,
    dt,
    ht,
    Ot = x.inspectSource,
    St = v.WeakMap;

if ("function" == typeof St && /native code/.test(Ot(St))) {
  var jt = x.state || (x.state = new (0, v.WeakMap)()),
      wt = jt.get,
      Pt = jt.has,
      Tt = jt.set;
  mt = function mt(t, e) {
    return e.facade = t, Tt.call(jt, t, e), e;
  }, dt = function dt(t) {
    return wt.call(jt, t) || {};
  }, ht = function ht(t) {
    return Pt.call(jt, t);
  };
} else {
  var Lt = ct("state");
  K[Lt] = !0, mt = function mt(t, e) {
    return e.facade = t, _(t, Lt, e), e;
  }, dt = function dt(t) {
    return A(t, Lt) ? t[Lt] : {};
  }, ht = function ht(t) {
    return A(t, Lt);
  };
}

var _t,
    kt,
    xt,
    Et = {
  set: mt,
  get: dt,
  has: ht,
  enforce: function enforce(t) {
    return ht(t) ? dt(t) : mt(t, {});
  },
  getterFor: function getterFor(t) {
    return function (e) {
      var r;
      if (!m(e) || (r = dt(e)).type !== t) throw TypeError("Incompatible receiver, " + t + " required");
      return r;
    };
  }
},
    Mt = {}.propertyIsEnumerable,
    At = Object.getOwnPropertyDescriptor,
    It = {
  f: At && !Mt.call({
    1: 2
  }, 1) ? function (t) {
    var e = At(this, t);
    return !!e && e.enumerable;
  } : Mt
},
    Rt = Object.getOwnPropertyDescriptor,
    Ct = {
  f: b ? Rt : function (t, e) {
    if (t = s(t), e = w(e, !0), S) try {
      return Rt(t, e);
    } catch (t) {}
    if (A(t, e)) return L(!It.f.call(t, e), t[e]);
  }
},
    Ft = p(function (t) {
  var e = Et.get,
      r = Et.enforce,
      n = String(String).split("String");
  (t.exports = function (t, e, o, i) {
    var u,
        c = !!i && !!i.unsafe,
        a = !!i && !!i.enumerable,
        f = !!i && !!i.noTargetGet;
    "function" == typeof o && ("string" != typeof e || A(o, "name") || _(o, "name", e), (u = r(o)).source || (u.source = n.join("string" == typeof e ? e : ""))), t !== v ? (c ? !f && t[e] && (a = !0) : delete t[e], a ? t[e] = o : _(t, e, o)) : a ? t[e] = o : k(e, o);
  })(Function.prototype, "toString", function () {
    return "function" == typeof this && e(this).source || Ot(this);
  });
}),
    Dt = Z.concat("length", "prototype"),
    Gt = {
  f: Object.getOwnPropertyNames || function (t) {
    return Q(t, Dt);
  }
},
    Nt = {
  f: Object.getOwnPropertySymbols
},
    Vt = ot("Reflect", "ownKeys") || function (t) {
  var e = Gt.f(j(t)),
      r = Nt.f;
  return r ? e.concat(r(t)) : e;
},
    Ht = function Ht(t, e) {
  for (var r = Vt(e), n = T.f, o = Ct.f, i = 0; i < r.length; i++) {
    var u = r[i];
    A(t, u) || n(t, u, o(e, u));
  }
},
    Wt = /#|\.prototype\./,
    Xt = function Xt(t, e) {
  var r = zt[qt(t)];
  return r == Yt || r != Bt && ("function" == typeof e ? i(e) : !!e);
},
    qt = Xt.normalize = function (t) {
  return String(t).replace(Wt, ".").toLowerCase();
},
    zt = Xt.data = {},
    Bt = Xt.NATIVE = "N",
    Yt = Xt.POLYFILL = "P",
    Ut = Xt,
    $t = Ct.f,
    Kt = function Kt(t, e) {
  var r,
      n,
      o,
      i,
      u,
      c = t.target,
      a = t.global,
      f = t.stat;
  if (r = a ? v : f ? v[c] || k(c, {}) : (v[c] || {}).prototype) for (n in e) {
    if (i = e[n], o = t.noTargetGet ? (u = $t(r, n)) && u.value : r[n], !Ut(a ? n : c + (f ? "." : "#") + n, t.forced) && void 0 !== o) {
      if (typeof i == typeof o) continue;
      Ht(i, o);
    }

    (t.sham || o && o.sham) && _(i, "sham", !0), Ft(r, n, i, t);
  }
},
    Jt = function Jt(t) {
  return Object(f(t));
},
    Qt = !i(function () {
  function t() {}

  return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
}),
    Zt = ct("IE_PROTO"),
    te = Object.prototype,
    ee = Qt ? Object.getPrototypeOf : function (t) {
  return t = Jt(t), A(t, Zt) ? t[Zt] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? te : null;
},
    re = H("iterator"),
    ne = !1;

[].keys && ("next" in (xt = [].keys()) ? (kt = ee(ee(xt))) !== Object.prototype && (_t = kt) : ne = !0), (null == _t || i(function () {
  var t = {};
  return _t[re].call(t) !== t;
})) && (_t = {}), A(_t, re) || _(_t, re, function () {
  return this;
});

var oe = {
  IteratorPrototype: _t,
  BUGGY_SAFARI_ITERATORS: ne
},
    ie = T.f,
    ue = H("toStringTag"),
    ce = function ce(t, e, r) {
  t && !A(t = r ? t : t.prototype, ue) && ie(t, ue, {
    configurable: !0,
    value: e
  });
},
    ae = oe.IteratorPrototype,
    fe = Object.setPrototypeOf || ("__proto__" in {} ? function () {
  var t,
      e = !1,
      r = {};

  try {
    (t = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(r, []), e = r instanceof Array;
  } catch (t) {}

  return function (r, n) {
    return j(r), function (t) {
      if (!m(t) && null !== t) throw TypeError("Can't set " + String(t) + " as a prototype");
    }(n), e ? t.call(r, n) : r.__proto__ = n, r;
  };
}() : void 0),
    se = oe.IteratorPrototype,
    le = oe.BUGGY_SAFARI_ITERATORS,
    pe = H("iterator"),
    ye = function ye() {
  return this;
},
    ge = Et.set,
    ve = Et.getterFor("Array Iterator"),
    be = function (t, e, r, n, o, i, u) {
  !function (t, e, r) {
    t.prototype = pt(ae, {
      next: L(1, function () {
        var t = ve(this),
            e = t.target,
            r = t.kind,
            n = t.index++;
        return !e || n >= e.length ? (t.target = void 0, {
          value: void 0,
          done: !0
        }) : "keys" == r ? {
          value: n,
          done: !1
        } : "values" == r ? {
          value: e[n],
          done: !1
        } : {
          value: [n, e[n]],
          done: !1
        };
      })
    }), ce(t, "Array Iterator", !1);
  }(r);

  var c,
      a,
      f,
      s = function s(t) {
    if (t === o && g) return g;
    if (!le && t in p) return p[t];

    switch (t) {
      case "keys":
      case "values":
      case "entries":
        return function () {
          return new r(this, t);
        };
    }

    return function () {
      return new r(this);
    };
  },
      l = !1,
      p = t.prototype,
      y = p[pe] || p["@@iterator"] || p.values,
      g = !le && y || s(o),
      v = p.entries || y;

  if (v && (c = ee(v.call(new t())), se !== Object.prototype && c.next && (ee(c) !== se && (fe ? fe(c, se) : "function" != typeof c[pe] && _(c, pe, ye)), ce(c, "Array Iterator", !0))), y && "values" !== y.name && (l = !0, g = function g() {
    return y.call(this);
  }), p[pe] !== g && _(p, pe, g), void (a = {
    values: s("values"),
    keys: s("keys"),
    entries: s("entries")
  })) for (f in a) {
    (le || l || !(f in p)) && Ft(p, f, a[f]);
  } else Kt({
    target: "Array",
    proto: !0,
    forced: le || l
  }, a);
  return a;
}(Array, 0, function (t, e) {
  ge(this, {
    type: "Array Iterator",
    target: s(t),
    index: 0,
    kind: e
  });
}, 0, "values");

vt("keys"), vt("values"), vt("entries");
var me = Object.assign,
    de = Object.defineProperty,
    he = !me || i(function () {
  if (b && 1 !== me({
    b: 1
  }, me(de({}, "a", {
    enumerable: !0,
    get: function get() {
      de(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), {
    b: 2
  })).b) return !0;
  var t = {},
      e = {},
      r = Symbol(),
      n = "abcdefghijklmnopqrst";
  return t[r] = 7, n.split("").forEach(function (t) {
    e[t] = t;
  }), 7 != me({}, t)[r] || tt(me({}, e)).join("") != n;
}) ? function (t, e) {
  for (var r = Jt(t), n = arguments.length, o = 1, i = Nt.f, u = It.f; n > o;) {
    for (var c, f = a(arguments[o++]), s = i ? tt(f).concat(i(f)) : tt(f), l = s.length, p = 0; l > p;) {
      c = s[p++], b && !u.call(f, c) || (r[c] = f[c]);
    }
  }

  return r;
} : me;
Kt({
  target: "Object",
  stat: !0,
  forced: Object.assign !== he
}, {
  assign: he
});

var Oe = "\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF",
    Se = "[" + Oe + "]",
    je = RegExp("^" + Se + Se + "*"),
    we = RegExp(Se + Se + "*$"),
    Pe = function Pe(t) {
  return function (e) {
    var r = String(f(e));
    return 1 & t && (r = r.replace(je, "")), 2 & t && (r = r.replace(we, "")), r;
  };
},
    Te = (Pe(1), Pe(2), Pe(3));

Kt({
  target: "String",
  proto: !0,
  forced: i(function () {
    return !!Oe.trim() || "​᠎" != "​᠎".trim() || "trim" !== Oe.trim.name;
  })
}, {
  trim: function trim() {
    return Te(this);
  }
});

var Le = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
},
    _e = H("iterator"),
    ke = H("toStringTag"),
    xe = be.values;

for (var Ee in Le) {
  var Me = v[Ee],
      Ae = Me && Me.prototype;

  if (Ae) {
    if (Ae[_e] !== xe) try {
      _(Ae, _e, xe);
    } catch (t) {
      Ae[_e] = xe;
    }
    if (Ae[ke] || _(Ae, ke, Ee), Le[Ee]) for (var Ie in be) {
      if (Ae[Ie] !== be[Ie]) try {
        _(Ae, Ie, be[Ie]);
      } catch (t) {
        Ae[Ie] = be[Ie];
      }
    }
  }
}

export default (function (i) {
  var _i$scope = i.scope,
      u = _i$scope === void 0 ? {} : _i$scope,
      _i$components = i.components,
      c = _i$components === void 0 ? {} : _i$components,
      _i$remarkPlugins = i.remarkPlugins,
      a = _i$remarkPlugins === void 0 ? [] : _i$remarkPlugins,
      _i$rehypePlugins = i.rehypePlugins,
      f = _i$rehypePlugins === void 0 ? [] : _i$rehypePlugins,
      s = i.children,
      l = function (t, e) {
    if (null == t) return {};
    var r,
        n,
        o = {},
        i = Object.keys(t);

    for (n = 0; n < i.length; n++) {
      e.indexOf(r = i[n]) >= 0 || (o[r] = t[r]);
    }

    return o;
  }(i, ["scope", "components", "remarkPlugins", "rehypePlugins", "children"]);

  var p = Object.assign({
    mdx: n,
    MDXProvider: o,
    components: c,
    props: l
  }, u),
      y = r.sync(s, {
    remarkPlugins: a,
    rehypePlugins: f,
    skipExport: !0
  }).trim(),
      g = e(y, {
    objectAssign: "Object.assign"
  }).code,
      v = Object.keys(p),
      b = Object.values(p);
  return _construct(Function, ["React"].concat(_toConsumableArray(v), ["".concat(g, "\n\nreturn React.createElement(\n  MDXProvider,\n  {components},\n  React.createElement(MDXContent, props)\n)")])).apply(void 0, [t].concat(_toConsumableArray(b)));
});